<mat-horizontal-stepper
  orientation="horizontal"
  linear
  #stepper
  (selectionChange)="onStepChange($event)"
>
  <ng-template matStepperIcon="edit">
    <mat-icon>done</mat-icon>
  </ng-template>

  <mat-step
    *ngFor="let item of stepperData; let i = index"
    [completed]="item.completed"
  >
    <ng-template matStepLabel>
      {{ item.stepper | translate }}
      <br />
    </ng-template>
  </mat-step>
</mat-horizontal-stepper>
